import EventList from "./index.vue";

export default EventList;
